import type { Attachment } from '@missionlabs/smartagent-service-thread'
import classNames from 'classnames'
import UploadMultipleAttachments from '../../components/UploadMultipleAttachments'
import styles from './UploadMultipleAttachments.module.scss'

interface Props {
    isLoading: boolean
    channel: string
    isEditorRedesigned?: boolean
    onAttachStart: (files: File[]) => void
    onAttachEnd: (attachments: Attachment[]) => void
    onError: (message: string) => void
}

const UploadAttachments = ({
    channel,
    isLoading,
    isEditorRedesigned,
    onAttachStart,
    onAttachEnd,
    onError,
}: Props) => {
    return (
        <UploadMultipleAttachments
            key="upload-attachments"
            channel={channel}
            className={
                isEditorRedesigned ? '' : classNames('rdw-option-wrapper', styles.attachments)
            }
            isLoading={isLoading}
            isEditorRedesigned={isEditorRedesigned}
            onAttachStart={onAttachStart}
            onAttachEnd={onAttachEnd}
            onError={onError}
        />
    )
}

export default UploadAttachments
